import header from "./header.jpg";
import footer from "./footer.jpg";
import { useState, useRef, useMemo } from "react";
import Input from "../custom-control/Input";

import MobileInput from "../custom-control/MobileInput";
import styles from "./MyForm.module.scss";
import { isEmail,} from "../util/validator";
/* import Select from "../custom-control/Select"; */

import { useNavigate, useLocation } from "react-router-dom";
import GoogleAddressInput from "../custom-control/GoogleAddressInput";

import { Blocks } from "react-loader-spinner";
import useFetch from "../hooks/useFetch";
import { insertReferral } from "../http";



export default function MyForm() {
  const [emailIsInvalid, setEmailIsInvalid] = useState(false);
  const [errors, setErrors] = useState({});
  const [serverErrors, setServerErrors] = useState([]);
  

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = useMemo(() => {
    const params = {};
    const search = new URLSearchParams(location.search);
    search.forEach((value, key) => {
      const trimmedKey = key.trim();
      const trimmedValue = typeof value === "string" ? value.trim() : value;
      params[trimmedKey] = trimmedValue;
      const lowerKey = trimmedKey.toLowerCase();
      if (lowerKey !== trimmedKey) {
        params[lowerKey] = trimmedValue;
      }
    });
    return params;
  }, [location.search]);

  const { isLoading, loadingText, setIsLoading, setLoadingText } = useFetch();


  async function sumbitHandler(event) {
    event.preventDefault();
    const fd = new FormData(event.target);
    const formData = Object.fromEntries(fd.entries());
    const agentId =
      queryParams.id ??
      queryParams["id"] ??
      "";
    if (agentId) {
      formData.agentId = agentId;
    }
    const requestBody = { ...queryParams, ...formData };
    console.log(`query params are: ${JSON.stringify(queryParams)}`);
    console.log(`request body is: ${JSON.stringify(requestBody)}`);
    const formErrors = {};
    let formIsValid = true;
    //validate the input here

    // if (!formData["AgentId"]) {
    //   formErrors["AgentId"] = "Agent required";

    //   formIsValid = false;
    // }
    if (!formData["FirstName"]) {
      formErrors["FirstName"] = "First name required";

      formIsValid = false;
    }
    if (!formData["LastName"]) {
      formErrors["LastName"] = "Last name required";
      formIsValid = false;
    }

    if (!formData["AddressLine1"]) {
      formErrors["AddressLine1"] = "Street address is required";
      formIsValid = false;
    }
    if (!formData["Suburb"]) {
      formErrors["Suburb"] = "Suburb is required";
      formIsValid = false;
    }
    if (!formData["State"]) {
      formErrors["State"] = "State is required";
      formIsValid = false;
    }
    if (!formData["Postcode"]) {
      formErrors["Postcode"] = "Postcode is required";
      formIsValid = false;
    }
    // if (!formData["Occupation"]) {
    //   formErrors["Occupation"] = "Occupation is required";
    //   formIsValid = false;
    // }
    setErrors(formErrors);
  
   // console.log(errors);
   if(formIsValid)
   {

    setIsLoading(true);
    setLoadingText("saving data, please wait...")
       insertReferral(requestBody)
      .then((response) => {
     
        console.log(response.data);
        if(response.data.ApiResults.length===0)
        {
          navigate("completion");
        }
        setServerErrors(response.data.ApiResults);
        window.scrollTo(0, 0)
      })
      .catch((error) => {})
      .finally(() => {

        setIsLoading(false);
      });
   }
   

    // fetch(url, {
  }

  function clearErrorHandler(id){
    setErrors((prev)=>{
        let errs = {...prev};
        errs[id]='';
        return errs;
    })
  }
  function setErrorHandler(id){
    setErrors((prev)=>{
        let errs = {...prev};
        errs[id]=`${id} required`;
        return errs;
    })
  }
  function handleOnBlur(event) {
    console.log(event.target.value);
    const node = event.target;
    if (node.name === "email") {
      setEmailIsInvalid(!isEmail(node.value));
    }
  }

  const ref = useRef(null);

  if(isLoading)
  {
    return (
  <div className={styles.hvCenter} >  <Blocks
  height="80"
  width="80"
  color="#4fa94d"
  ariaLabel="blocks-loading"
  wrapperStyle={{}}
  wrapperClass="blocks-wrapper"
  visible={isLoading}/>
    <p>{loadingText}</p>
  
  </div>

  

)}
else{
  return (
    <>

      <div className={styles.page}>
      <img src={header} alt="logo" className={styles.headerImage} />
        <form
          id="form"
          name="form"
          className={styles.form}
          onSubmit={sumbitHandler}
        >

          <div className={styles.error}>

          {serverErrors.length>0 && <p>Failed to save data due to: </p>}
          </div>
          <ul style={{listStyle:"none"}}>
            {serverErrors &&
           
              serverErrors.map((err) => (
                <li className={styles.error} style={{fontSize:'13px'}}>
                  {err.Code} -- {err.Description}
                </li>
              ))}
          </ul>
{/*           <Select
            name="AgentId"
            id="AgentId"
            label="Agent"
            mandatory={true}
            placeHolder="---Select Agent---"
            values={agentList}
            clearError={clearErrorHandler}
            setError={setErrorHandler}
            error={errors["AgentId"] ? "Agent is required" : ""}
          ></Select> */}
          
          <Input
            name="FirstName"
            id="FirstName"
            label="First Name"
            mandatory={true}
            ref={ref}   
            clearError={clearErrorHandler}
            setError={setErrorHandler}
            error={errors["FirstName"] ? "First name is required" : ""}
          />
          <Input
            name="LastName"
            id="LastName"
            label="Last Name"
            type="text"
            mandatory={true}
            clearError={clearErrorHandler}
            setError={setErrorHandler}
            error={errors["LastName"] ? "Last name is required" : ""}
          />
          <Input
            name="Email"
            id="Email"
            label="Email"
            type="Email"
            mandatory={true}
            clearError={clearErrorHandler}
            setError={setErrorHandler}
            onBlur={handleOnBlur}
            error={errors["Email"] ? "Email is required" : emailIsInvalid ? "Invalid email address" : ""}
     
          />

          {/* <MyInput type="Date" name="Dob" id="Dob" label="Date Of Birth" /> */}
          <Input name="Phone" id="Phone" type="text" label="Phone" />
          <MobileInput name="Mobile" id="Mobile" type="text" label="Mobile"/>
          {/* <Input name="mobile" id="mobile" type="text" label="Mobile" /> */}

              <GoogleAddressInput label="Street Address"   clearError={clearErrorHandler}
            setError={setErrorHandler}  errors={errors}></GoogleAddressInput>
          <Input
            name="Occupation"
            id="Occupation"
            type="text"
            label="Occupation"
          />
          <div className={styles.submitWrapper}>
            <button aria-label="submit-button" className={styles.submit}>SUBMIT</button>
           
          </div>
        </form>
        <img src={footer} alt="logo" className={styles.headerImage} />
      </div>
    </>
  )};
}
